import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Row, Col } from 'react-flexbox-grid';

import FormField from 'containers/FormField';
import LikertField from 'components/LikertField';

import FormProvider from 'routes/Documents/containers/FormProvider';

import { msisSection, msisWrapper, sectionWrapper, msisHeader } from './Scores.less';

import MSISSections from '../MSISSections';

const MSISForm = props => (
  <FormProvider {...props}>
    <div className={msisWrapper}>
      <div className={sectionWrapper}>
        <h5 className={msisHeader}>
          <FormattedMessage id="msis.header.msLimits" />
        </h5>
        {MSISSections.msLimits.map(ms => (
          <div key={`msis_${ms}`}>
            <Grid fluid className={msisSection}>
              <Row middle="xs">
                <Col xs={5}>
                  <h6>
                    <FormattedMessage id={`msis.section.${ms}`} />
                  </h6>
                </Col>
                <Col xs={7}>
                  <FormField
                    name={ms}
                    component={LikertField}
                    max={5}
                    minLabel="msis.label.disagree"
                    maxLabel="msis.label.agree"
                  />
                </Col>
              </Row>
            </Grid>
          </div>
        ))}
      </div>
      <div className={sectionWrapper}>
        <h5 className={msisHeader}>
          <FormattedMessage id="msis.header.bothers" />
        </h5>
        {MSISSections.bothers.map(ms => (
          <div key={`msis_${ms}`}>
            <Grid fluid className={msisSection}>
              <Row middle="xs">
                <Col xs={5}>
                  <h6>
                    <FormattedMessage id={`msis.section.${ms}`} />
                  </h6>
                </Col>
                <Col xs={7}>
                  <FormField
                    name={ms}
                    component={LikertField}
                    max={5}
                    minLabel="msis.label.disagree"
                    maxLabel="msis.label.agree"
                  />
                </Col>
              </Row>
            </Grid>
          </div>
        ))}
      </div>
    </div>
  </FormProvider>
);

export default MSISForm;
